export default "__VITE_ASSET__DoDgTvMy__"